import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import * as React from 'react';
import styled from 'styled-components';
import { horizontalSpace } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';

const Container = styled.div`
  display: flex;
  align-items: center;
  ${horizontalSpace(4)};
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    color: ${colorsV2.gray180};
    width: 20px;
    height: 20px;
  }
`;

interface AuthorAchievementInfoItemProps {
  icon?: React.ReactNode;
  highLightText?: string;
  normalText?: string;
}

export const AuthorAchievementInfoItem = ({ icon, highLightText, normalText }: AuthorAchievementInfoItemProps) => {
  if (!highLightText && !normalText) return null;
  return (
    <Container className="author-achievement-info-item">
      <IconWrapper>{icon}</IconWrapper>
      <ResponsiveTypography.Paragraph color="gray180" variant="semi-bold/16-24">
        {highLightText}
      </ResponsiveTypography.Paragraph>
      <ResponsiveTypography.Paragraph color="gray160" variant="regular/16-24">
        {normalText}
      </ResponsiveTypography.Paragraph>
    </Container>
  );
};
